import { useState } from 'react';

const useExchangeSelect = (initialItems, availableItems) => {
    const [itemsData, setItemsData] = useState({
        from: initialItems[0], 
        to: initialItems[1]   
    });
   
    const handleItemChange = (newItemId, direction) => {
        let switchItems = false;
        if (availableItems.length === 2) {
            switchItems = true;
        }

        if (switchItems || direction==='switch') {
            setItemsData(prev => ({
                from: prev.to,
                to: prev.from
            }));
        }else {
            setItemsData(prev => ({
                ...prev,
                [direction]: availableItems.find(item => item.id === newItemId)
            }));
        }
    };

    return [ itemsData, handleItemChange ];
};

export { useExchangeSelect };
